<div class="row">
  <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3">
    <h3>{{'i18n.core.navigation.editProfile' | translate}}</h3>
    <app-user-edit-form [userEditForm]="userEditForm"></app-user-edit-form>
  </div>
</div>
<div class="row">
  <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3">
    <button type="submit"
            class="btn btn-primary float-right"
            (click)="save()"
            [disabled]="!userEditForm.valid">
      {{ "i18n.shared.save" | translate }}
    </button>
  </div>
</div>
